import { render, staticRenderFns } from "./utils-test-page.vue?vue&type=template&id=d98a9ce2&scoped=true"
import script from "./utils-test-page.vue?vue&type=script&lang=js"
export * from "./utils-test-page.vue?vue&type=script&lang=js"
import style0 from "./utils-test-page.vue?vue&type=style&index=0&id=d98a9ce2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a9ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d98a9ce2')) {
      api.createRecord('d98a9ce2', component.options)
    } else {
      api.reload('d98a9ce2', component.options)
    }
    module.hot.accept("./utils-test-page.vue?vue&type=template&id=d98a9ce2&scoped=true", function () {
      api.rerender('d98a9ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/utils-test-page.vue"
export default component.exports